<div class="wrapper-notification-popup">
  <div
    class="title-style fw-bold w-100 d-flex align-items-center justify-content-center"
  >
    <span [ngClass]="{ 'title-test': isAllNotification }"
      >My Notifications</span
    >
    <div class="input-search" *ngIf="isAllNotification">
      <input
        #notificationSearch
        type="text"
        class="form-control search-input"
        placeholder="Search notifications"
      />
      <img
        src="../../../../assets/icons/svg/search-notification.svg"
        alt="more"
        class="input-ico"
        height="18"
        width="18"
      />
    </div>
    <div
      [matMenuTriggerFor]="menu"
      class="view-more-icon d-flex align-items-center"
    >
      <img
        src="../../../../assets/icons/svg/more-vertical.svg"
        alt="more"
        class="action-i"
        height="19"
        width="15"
      />
      <mat-menu #menu="matMenu" class="dropdown-container" xPosition="before">
        <button
          mat-menu-item
          (click)="
            isAllNotification
              ? markNotificationsAsReadCall()
              : markUnreadAsRead()
          "
        >
          <img
            src="../../../../assets/icons/svg/check.svg"
            alt="check"
            height="25"
            width="24"
          /><span class="ms-2 notification-menu-text">Mark all as read</span>
        </button>
        <button mat-menu-item (click)="toggleNotificationsAlert()">
          <img
            src="../../../../assets/icons/svg/notification-mute.svg"
            alt="mute"
            height="24"
            width="24"
          /><span class="ms-2 notification-menu-text"
            >Turn ON/OFF notifications</span
          >
        </button>
        <button
          mat-menu-item
          (click)="
            isAllNotification
              ? deleteNotificationsCall()
              : deleteAllFromUnreadList()
          "
        >
          <img
            src="../../../../assets/icons/svg/garbage-delete.svg"
            alt="Delete"
            height="19"
            width="24"
          /><span class="ms-2 delete-text notification-menu-text"
            >Delete All</span
          >
        </button>
      </mat-menu>
    </div>
    <img
      *ngIf="isAllNotification"
      src="../../../assets/icons/svg/x-circle.svg"
      class="action-i cursor-pointer ms-3"
      alt="close"
      height="24"
      width="24"
      (click)="closeFn()"
      (keydown)="closeFn()"
    />
  </div>
  <div class="content-style">
    <div
      (scroll)="isAllNotification && onScroll($event)"
      class="scrollable-notification-list scrollbar-custom-scroll-style"
      [ngClass]="{
        'all-notification': isAllNotification,
        'unread-notification': !isAllNotification && !isLoadingNotification
      }"
      *ngIf="(notification?.length || 0) > 0; else noNotifications"
    >
      <ng-container *ngIf="isAllNotification; else unreadNotifications">
        <app-view-all-notification-item
          [@fadeOut]
          *ngFor="let item of notification; let i = index"
          [index]="i"
          [notificationData]="item"
          [previousNotification]="i > 0 ? notification[i - 1] : null"
          (onMarkAsReadEvent)="markNotificationAsRead($event)"
          (openNotificationEvent)="openNotification($event)"
          (onDeleteNotificationEvent)="deleteNotification($event)"
        />
      </ng-container>
      <ng-template #unreadNotifications>
        <ng-container *ngFor="let item of notification; let i = index">
          <app-notification-item
            [@fadeOut]
            [index]="i"
            [notificationData]="item"
            [previousNotification]="i > 0 ? notification[i - 1] : null"
            (onMarkAsReadEvent)="markNotificationAsRead($event)"
            (openNotificationEvent)="openNotification($event)"
            (onDeleteNotificationEvent)="deleteNotification($event)"
          />
        </ng-container>
      </ng-template>

      <div
        *ngIf="isLoadingNotification && isAllNotification"
        class="loading-spinner all-loader"
        id="notification-loader-ui"
      >
        <span class="spinner-border spinner-border-save"></span>
        <span class="spinner-text">Loading...</span>
      </div>
    </div>

    <div *ngIf="isLoadingNotification" class="loading-spinner">
      <span class="spinner-border spinner-border-save"></span>
      <span class="spinner-text">Loading...</span>
    </div>

    <button
      class="notification-all"
      (click)="openNotificationPopup()"
      *ngIf="!isAllNotification"
    >
      See All Notifications
    </button>

    <ng-template #noNotifications>
      <div
        class="no-notifications"
        *ngIf="!isLoadingNotification"
        [ngClass]="{
          'no-notification': !isAllNotification
        }"
      >
        <img
          src="../../../../assets/icons/svg/notification-mail.svg"
          alt="No Notifications"
          class="no-notification-icon"
        />
        <span class="no-notification-text"
          >No {{ isAllNotification ? "" : "Unread" }} Notifications</span
        >
      </div>
    </ng-template>
  </div>

  <div class="alert-settings-overlay" *ngIf="showAlertSettings">
    <div class="py-2">
      <img
        src="../../../../assets/icons/svg/notification-mute.svg"
        alt="mute"
        height="24"
        width="24"
      /><span class="ms-2 notification-menu-text"
        >Turn ON/OFF notifications</span
      >
    </div>
    <div class="checkers">
      <div class="checkbox-group">
        <label class="checkbox container-checkbox" id="app-notification"
          ><input
            type="checkbox"
            id="app-notification"
            [(ngModel)]="userAlertSettings.receive_in_app_alert"
          /><span class="checkmark-checkbox"></span>In-App Notification</label
        >

        <label class="checkbox container-checkbox" id="email-notification"
          ><input
            type="checkbox"
            id="email-notification"
            [(ngModel)]="userAlertSettings.receive_email_alert"
          /><span class="checkmark-checkbox"></span>E-Mail Notification</label
        >
      </div>
    </div>
    <div class="buttons-section p-2 w-100">
      <button class="cancel" (click)="toggleNotificationsAlert()">
        Cancel
      </button>
      <button class="confirm" (click)="confirmUserSettings()">Confirm</button>
    </div>
  </div>
</div>
